var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5386 27.47L22.1161 21.0475C23.9476 18.9413 24.8898 16.2062 24.744 13.4189C24.5982 10.6316 23.376 8.00977 21.3348 6.10608C19.2937 4.20238 16.5931 3.16556 13.8024 3.21416C11.0117 3.26276 8.34891 4.393 6.37529 6.36662C4.40167 8.34024 3.27143 11.0031 3.22283 13.7938C3.17422 16.5844 4.21105 19.285 6.11474 21.3262C8.01844 23.3673 10.6403 24.5896 13.4276 24.7353C16.2149 24.8811 18.9499 23.9389 21.0561 22.1075L27.4786 28.53C27.6208 28.6624 27.8089 28.7346 28.0032 28.7311C28.1975 28.7277 28.3828 28.649 28.5203 28.5116C28.6577 28.3742 28.7364 28.1888 28.7398 27.9945C28.7432 27.8002 28.6711 27.6121 28.5386 27.47ZM4.75863 14C4.75863 12.1705 5.30114 10.3821 6.31754 8.86094C7.33394 7.33979 8.77859 6.15419 10.4688 5.45408C12.159 4.75397 14.0189 4.57079 15.8132 4.9277C17.6075 5.28462 19.2557 6.16559 20.5494 7.45923C21.843 8.75286 22.724 10.4011 23.0809 12.1954C23.4378 13.9897 23.2546 15.8496 22.5545 17.5398C21.8544 19.23 20.6688 20.6747 19.1477 21.6911C17.6265 22.7075 15.8381 23.25 14.0086 23.25C11.5563 23.247 9.20525 22.2715 7.47118 20.5374C5.73712 18.8033 4.76161 16.4523 4.75863 14Z",
    fill: "#19191C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6a133fa04eda21578dfa882011fbbaca.svg";
export { ForwardRef as ReactComponent };